export default {
	string: state => state.string,
	header: state => state.header,
	users:  state => state.users,
};
